import { error } from "console";
import { AuditQuestion } from "../models/AuditQuestion";
import { Audit } from "../models/Audit";
import { AuditDetail } from "../models/AuditDetail";
import { AuditModule } from "../models/AuditModule";
import axios, { AxiosRequestConfig } from "axios";
import { saveAs } from "file-saver";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const insertAuditModule = async (module: AuditModule) => {
  const response = await fetch(`${API_BASE_URL}/AuditModule/Insert`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(module),
  });

  return response;
};

const updateAuditModule = async (module: AuditModule) => {
  const response = await fetch(`${API_BASE_URL}/AuditModule/Update`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(module),
  });

  return response;
};

const deleteAuditModule = async (module: AuditModule) => {
  const response = await fetch(`${API_BASE_URL}/AuditModule/Delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(module),
  });

  return response;
};

const updatePositions = async (
  updates: { moduleId: number; newPosition: number }[]
) => {
  const response = await fetch(`${API_BASE_URL}/AuditModule/UpdatePositions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updates),
  });

  if (!response.ok) {
    throw new Error("Failed to update module positions");
  }

  return response;
};

const AuditModuleService = {
  insertAuditModule,
  updateAuditModule,
  deleteAuditModule,
  updatePositions,
};

export default AuditModuleService;
